import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeedbackJourneyComponent } from './feedback-journey.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { API } from './../../utils/api/api.service';
import { PlatformService } from '../../services/platform.services';
import { CookieService } from '../../services/cookie.service';
export class FeedbackJourneyModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: FeedbackJourneyModule,
      providers: [API],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TNKUtilitiesModule,
    RouterModule,
  ],
  declarations: [FeedbackJourneyComponent],
  exports: [FeedbackJourneyComponent],
  providers: [API, PlatformService, CookieService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FeedbackJourneyModule_tsickle_Closure_declarations() {
/** @type {?} */
FeedbackJourneyModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FeedbackJourneyModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
